import { render, staticRenderFns } from "./StepProgress.vue?vue&type=template&id=05870836&scoped=true&"
import script from "./StepProgress.vue?vue&type=script&lang=js&"
export * from "./StepProgress.vue?vue&type=script&lang=js&"
import style0 from "./StepProgress.vue?vue&type=style&index=0&id=05870836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05870836",
  null
  
)

export default component.exports